<script lang="ts">
	import ContentEditable from "#lib/components/ContentEditable.svelte";

	interface Props {
		value: string;
		onChange?: (value: string | undefined) => void;
		onCommit?: (value: string | undefined) => void;
	}

	let { value = $bindable(), onChange, onCommit }: Props = $props();

	let showPlaceholder = $state(!value);
</script>

<ContentEditable bind:value allowEmpty placeholder={showPlaceholder ? "Add description" : undefined} onFocus={() => (showPlaceholder = false)} onFocusout={() => (showPlaceholder = !value)} class="mb-1 text-xs text-gray-500 before:hover:underline focus:ring-offset-2" minLength={12} {onChange} {onCommit} />
